import React from 'react';
import './ContactPage.css';
import ContactSection from "../components/ContactSection";
import SEO from "../components/SEO";
import { PAGES_SEO } from "../seo/pagesSeo";

export default function ContactPage() {
    const seo = PAGES_SEO.contact;
    return (
        <>
            <SEO title={seo.title} description={seo.description} path={seo.path} />
            <ContactSection />
        </>
    );
}
